import React from 'react';
import { TableCell, Table, TableBody, TableRow } from '@material-ui/core';
import classnames from 'classnames';
import { ReactComponent as RefreshIcon } from 'assets/images/refresh.svg';
import { TerminalRemote } from 'services/clients/terminal';
import { Cells } from './cells';
import { useStyles } from './styles';

interface Props {
  terminals: TerminalRemote[];
  lastRefreshData?: Record<
    string,
    Record<string, { last_recording_time: string; total_appointments: null | number }>
  >;
  selectedSlKey: string;
}

export const LastRefresh: React.FC<Props> = (props) => {
  const { terminals } = props;
  const classes = useStyles();

  return (
    <Table className={classes.table} aria-label="last refresh table">
      <TableBody>
        <TableRow className={classes.row}>
          <TableCell className={classnames(classes.headerCell)}>
            <div className="flex space-x-2 items-center">
              <RefreshIcon className={classes.icon} />
              <span>Last refresh</span>
            </div>
          </TableCell>
          <Cells
            terminals={terminals}
            classes={classes}
            lastRefreshData={props.lastRefreshData}
            selectedSlKey={props.selectedSlKey}
          />
        </TableRow>
      </TableBody>
    </Table>
  );
};
LastRefresh.displayName = 'LastRefresh';
